/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUserAssetsRemark.vue?vue&type=template&id=05e3c7bc&scoped=true"
import script from "./popUserAssetsRemark.vue?vue&type=script&lang=js"
export * from "./popUserAssetsRemark.vue?vue&type=script&lang=js"
import style0 from "./popUserAssetsRemark.vue?vue&type=style&index=0&id=05e3c7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e3c7bc",
  null
  
)

export default component.exports